import {
  filterProductOptions,
  filterProductOptionsV2,
} from "./product-filtering"

const ACTIONS = ["add", "choose", "enter", "select", "engrave", "upload"]
const ACTIONS_REGEXP = new RegExp(`\\b(${ACTIONS.join("|")})\\b`, "i")

const getHeadingPrefix = (pref, heading) => {
  if (heading.match(ACTIONS_REGEXP)) {
    return null
  }

  switch (pref) {
    case "ef":
    case "ef2":
      return "Add"
    case "o1":
      return "Choose"
    case "ch":
    case "sz":
      return "Select Your"
    default:
      return "Choose Your"
  }
}

const displayOptionHeading = (
  wizardData,
  pref,
  choices,
  shouldUseNewWizardExp
) => {
  let heading = wizardData?.heading?.title
  const selectedValue = choices[pref]?.value

  if (wizardData?.heading?.titles?.options) {
    const titleOptions = filterProductOptionsV2(
      wizardData.heading.titles.options,
      choices
    )
    if (titleOptions.length) {
      heading = titleOptions[0].label
    }
  }

  if ((pref === "ef" || pref === "ef2") && selectedValue) {
    const selectedOption = (wizardData?.options || []).find(
      (opt) => opt.value === selectedValue
    )

    if (selectedOption) {
      const filteredOptions = filterProductOptions(
        wizardData?.options || [],
        choices,
        true
      )
      if (filteredOptions.length > 1) {
        heading =
          heading +
          " " +
          `(${selectedOption.display_name ?? selectedOption.value})`
      }
    }
  }

  if (shouldUseNewWizardExp) {
    const prefix = getHeadingPrefix(pref, heading)
    if (prefix) {
      heading = prefix + " " + heading
    }
  }

  return heading
}

export default displayOptionHeading
